export const forgotPassword = {
    title: 'Quên mật khẩu',
    content: 'Vui lòng nhập email của bạn đã được đăng ký',
    button: 'Gửi',
    titleSwal: "Liên kết đặt lại mật khẩu đã được gửi",
    contentSwal: 'Vui lòng kiểm tra email của bạn và kiểm tra liên kết đặt lại mật khẩu'
};
